export default __webpack_public_path__ + "static/media/close-parent.db25f216.svg";